import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bf8085e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container filters mb-3 error-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col error" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "alert alert-warning d-flex flex-column align-items-center justify-content-center mt-3 mb-3",
      role: "alert"
    }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, "Nothing matched your search"),
      /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Please try another search.")
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}